/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Button component for table
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */
import { memo, ReactNode } from 'react';

import { Button } from '../index';
import { IButtonProps } from './Button';
import { ButtonTableContainerStyled } from './styled/ButtonTableStyled';

export interface IButtonTableProps extends IButtonProps {
    children: ReactNode;
}

const defaultProps = {
    onClick: () => {},
};

const ButtonTable = (props: IButtonTableProps) => (
    <ButtonTableContainerStyled>
        <Button {...props}>
            {props.children}
        </Button>
    </ButtonTableContainerStyled>
);

ButtonTable.defaultProps = defaultProps;

export default memo(ButtonTable);
